module.exports = __webpack_public_path__ + "static/media/icon_b.b085b128.png";